import { render, staticRenderFns } from "./TakeOutUser.vue?vue&type=template&id=563db01d&"
import script from "./TakeOutUser.vue?vue&type=script&lang=js&"
export * from "./TakeOutUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports